import React from 'react';
import { useTheme } from '../context/ThemeContext.jsx';

/**
 * "Theme   Light [switch] Dark" row for the account menu.
 * @returns {JSX.Element}
 */
export default function ThemeToggle() {
  const { theme, toggleTheme } = useTheme();
  const dark = theme === 'dark';
  return (
    <div className="flex items-center justify-between px-3 py-2 text-xs" data-testid="theme-row">
      <span className="text-white/60 font-medium">Theme</span>
      <div className="flex items-center gap-2">
        <span className={`text-[11px] font-medium ${dark ? 'text-white/40' : 'text-white'}`}>Light</span>
        <button
          type="button"
          role="switch"
          aria-checked={dark}
          aria-label="Dark theme"
          data-testid="theme-toggle"
          onClick={toggleTheme}
          className={`relative inline-flex h-5 w-9 shrink-0 cursor-pointer rounded-full border-2 border-transparent transition-colors duration-200 ease-in-out ${
            dark ? 'bg-civix-purple' : 'bg-slate-400'
          }`}
        >
          <span
            className={`pointer-events-none inline-block h-4 w-4 transform rounded-full bg-white shadow-md ring-0 transition duration-200 ease-in-out ${
              dark ? 'translate-x-4' : 'translate-x-0'
            }`}
          />
        </button>
        <span className={`text-[11px] font-medium ${dark ? 'text-white' : 'text-white/40'}`}>Dark</span>
      </div>
    </div>
  );
}
